// Left panel — shown when the app is detected: this machine's live status.
//
// Only one card can be real today: the daemon is loopback-only, so it describes
// the current machine and nothing else. The note below the card says so rather
// than padding the list with invented devices.
import styles from "../Connect.module.css";
import DeviceCard from "./DeviceCard";
import useThisDevice from "../useThisDevice";
import { openDesktopApp } from "../deepLink";

export default function ProtectedDevicesPanel() {
  const device = useThisDevice();

  return (
    <section className={styles.panel}>
      <h2 className={styles.panelTitle}>Your protected device</h2>
      <p className={styles.panelSubtitle}>
        Only the mobile or Desktop app can start or manage the protected tunnel.
      </p>

      <div className={styles.deviceList}>
        <DeviceCard device={device} onOpenInApp={openDesktopApp} />
      </div>

      <p className={styles.deviceListNote}>
        Only this machine can be shown — the local app reports on itself. Your
        other enrolled devices will appear here once the enterprise backend
        exposes them.
      </p>
    </section>
  );
}
